import DotLoader from './DotLoader'

export default DotLoader
